export default "__VITE_ASSET__1tVhtv_k__"